import * as paymentTypes from '@/constants/paymentTypes';

const CASH_REST_LABEL = 'cash';
const CASH_REST_NONE = 'none';
const TRANSFER_KEIMAHNI_REST_LABEL = 'transfer-foodsteps';
const TRANSFER_DAWR_REST_LABEL = 'transfer-restaurant';

// Payment types have values of cash, transfer-keimahni, transfer-dawr
// These do not make sense for restaurateur users. These users
// will see different labels for payment types
function getLabelForRestaurant(paymentType) {
    switch (paymentType) {
        case paymentTypes.NONE:
            return CASH_REST_NONE;
        case paymentTypes.CASH:
            return CASH_REST_LABEL;
        case paymentTypes.TRANSFER_KEIMAHNI:
            return TRANSFER_KEIMAHNI_REST_LABEL;
        case paymentTypes.TRANSFER_DAWR:
            return TRANSFER_DAWR_REST_LABEL;
        default:
            return null;
    }
}

export default {
    getLabelForRestaurant(paymentType) {
        return getLabelForRestaurant(paymentType);
    },
    // Get list to populate Vuetify's v-select. The list is a list
    // of objects with the expected text and value fields
    getSelectItemsForRestaurant() {
        return Object.values(paymentTypes).map(function(paymentType) {
            return {
                value: paymentType,
                text: getLabelForRestaurant(paymentType)
            };
        });
    }
};
